import axios from 'axios'

export async function userLoginCheck(dispatch){
    const logined = window.localStorage.getItem("logined")
    if( logined){
        dispatch({type:"CHECKING_LOGIN"})
        const res = await axios.post('/api/logincheck', {}, {withCredentials:true})
            .catch(error=>{
                console.log(error)
                dispatch({type:"LOGOUT"})
                return {data:{error:'error', 'result':'system'}}
            })
        if( res.data.error === 'ok'){
            const payload = {
                username:res.data.result.username,
                id:res.data.result.id,
                level:res.data.result.level,
            }
            dispatch({type:'LOGIN_SUCCESS', payload:payload})
            window.localStorage.setItem("logined",true)
            return true
        }
        dispatch({type:"LOGOUT"})
        return false
    }else{
        dispatch({type:"LOGOUT"})
        return false
    }
}

export async function userLogin(dispatch, loginPayload){
    const {id, password} = loginPayload
    const res = await axios.post('/api/login/', {id:id, password:password}, {withCredentials:true})
    
    if( res.data.error === 'ok'){
        const payload = {
            username:res.data.result.username,
            id: res.data.result.id,
            level:res.data.result.level,
        }
        dispatch({type:'LOGIN_SUCCESS', payload:payload})
        window.localStorage.setItem("logined",true)
        return true
    }else if( res.data.error === 'error'){
        dispatch({type:'LOGIN_ERROR', error:res.data.result})
        throw Error(res.data.result)
    }else{
        dispatch({type:'LOGIN_ERROR', error:'SYSTEM'})
        throw Error("system")
    }
}

export async function userLogout( dispatch ){
    dispatch({type:"LOGOUT"})
    window.localStorage.removeItem("logined")
    const res = await axios.post('/api/logout/')
    return res;
}